import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import AppWrapper from "../../../Common/AppWrapper";
import { withStyles } from "@material-ui/core/styles";
import {
  processSequence,
  scaleCoordinates,
  round,
  insertCutSites,
  processEditRegionSequence,
  objToCamel,
  calibrateThumb,
  findValidationMessage,
  handleValidationErrors,
} from "../../../../util/format.js";
import * as data from "../../../../sampleData/hdrSample.json";
import classNames from "classnames";
import _ from "underscore";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  ConfirmSubmissionHeader,
  ConfirmSubmissionSchematic,
  ConfirmSubmissionDiagram,
  HorizontalBar,
  ConfirmSubmissionSubHeader,
  ConfirmSubmissionDescription,
  ValidationErrorComponent,
} from "./GEComponents.jsx";
import { GeneEditSequenceDisplay } from "./GeneEditSequenceDisplay.jsx";
import { LabelWithTooltip } from "../../../Common/InputComponents/Inputs.jsx";
import { Thumb } from "../../../Common/Misc/TextSelector/Thumb.jsx";
import "../../AssayCreate.scss";
import { Button } from "react-bootstrap";
import * as assayActions from "../../../../actions/assays";

const styles = () => ({
  root: {
    position: "relative",
  },
  progress: {
    marginLeft: "0.25rem",
  },

  header: {},
  sub_header: {
    fontWeight: "400",
  },
  targetApp: {
    fontSize: "32px",
    fontWeight: "700",
  },
  cancel_button: {
    marginLeft: "10px",
    width: "30%",
  },
  diagram_header: {
    display: "inline-block",
    maxWidth: "100%",
    marginBottom: "5px",
    fontWeight: "700",
  },
  description: {
    fontSize: "14px",
    fontFamily: "Lato,Helvetica,Arial,sans-serif",
    lineHeight: "1.42857143",
  },
  schematic: {
    background: "#fefefe",

    boxShadow: "0",
    color: "#000",
    padding: "0",
    position: "relative",
  },
  selection_container: {
    outline: "solid #00a350",
  },

  label: {
    color: "#00a350",
    fontSize: "11px",
    fontWeight: "700",
    padding: "4px",
    margin: "5px 0 0 15px",
  },
  label_table: { marginRight: "18px" },
  row: {
    fontFamily: "'Courier New',Menlo,Monaco,Consolas,monospace",
    fontSize: "14px",
    margin: "4px",
  },
  data: {
    padding: "0 0 0 32px",
  },
  edits: {
    fontWeight: "700",
  },
  data_star: {
    color: "#00a350",
    padding: "0 0 0 32px",
    whiteSpace: "pre-wrap",
  },
  primary_header: {
    fontSize: "11px",
  },
  selection_area: {
    background: "#fefefe",

    boxShadow: "none",
    color: "#000",
    padding: "10px 0 10px 0",
    margin: "0",
  },
  selected: {
    background: "rgba(0, 255, 0, 0.4)",
  },
  hrBar: {},
  spanContainer: {
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingBottom: "20px",
  },
  geneElement: {
    width: "10px",
    height: "20px",
    fontFamily: "'Courier New',Menlo,Monaco,Consolas,monospace",
  },
  diagram_para: {
    fontFamily: "'Courier New',Menlo,Monaco,Consolas,monospace",
    marginLeft: "-24px",
    wordWrap: "break-word",
    fontSize: "14px",
  },
  span_element: {
    backgroundColor: "#e8e8e8",
  },
  homology: {
    width: "749px",
    marginTop: "2rem",
  },

  leftThumb: {
    zIndex: 8793,
    position: "absolute",
    paddingBottom: "22px",
    marginTop: "-6px",
    marginRight: "0",
  },
  rightThumb: {
    zIndex: 6999,
    position: "absolute",
    paddingTop: "19px",
    paddingRight: "0",
  },
});

/**
 * ConfirmSubmission
 * - Genome Edit Submission Confirmation Component for the GeneEditDetection Confirmation process.
 * @param {[object]} classes [Style object for the component]
 * @param {[object]} props [Props from the store and parent component]
 * @superComponent <App.js/>
 */

export class ConfirmSubmission extends React.Component {
  constructor(props) {
    super(props);
    // State for the schematic
    this.state = {
      left: 0, // div starting point.
      right: 0,
      width: 0,
      geneLength: 10,
      startIndex: 0,
      endIndex: 0,
      leftTranslatedIndex: 0,
      rightTranslatedIndex: 0,
      display: false,
    };

    this.toggleSchematic = this.toggleSchematic.bind(this);

    // Access the div dimensions through call back
    this.divRef = React.createRef();

    // Access the left Thumb node through the ref.
    this.leftThumbRef = React.createRef();

    // Access the right Thumb node through the ref
    this.rightThumbRef = React.createRef();
  }

  componentDidMount() {
    // Get the start and end from the API call -> data key.
    const { data } = this.props;
    const { EditRegionDonorRange } =
      (data &&
        !_.isEmpty(data) &&
        !_.isEmpty(data[0].Targets) &&
        data[0].Targets[0]) ||
      {};
    const { Start, End } = EditRegionDonorRange || {};

    // convert array index to count. Add 1 to the start and end
    const leftThumbInitialPoint = (!_.isUndefined(Start) && Start + 1) || 0;
    const rightThumbInitialPoint = (!_.isUndefined(End) && End + 2) || 0;
    // Initial points are validated against various inputs.
    this.setState({
      startIndex: Start || 0,
      endIndex: End || 0,
      leftTranslatedIndex: leftThumbInitialPoint,
      rightTranslatedIndex: rightThumbInitialPoint,
      initialStart: Start || 0,
      initialEnd: End || 0,
      selectionLeft: Start || 0,
      selectionRight: End + 1 || 0,
    });
  }
  // Get the dimensions for the dive.
  static getDerivedStateFromProps(nextProps, currState) {
    const { data } = nextProps || {};
    const { EditRegionDonorRange } =
      (data &&
        !_.isEmpty(data) &&
        !_.isEmpty(data[0].Targets) &&
        data[0].Targets[0]) ||
      {};
    const { Start, End } = EditRegionDonorRange || {};
    const didUpdate =
      (!_.isUndefined(Start) && currState.initialStart !== Start) ||
      (!_.isUndefined(End) && currState.initialEnd !== End);
    const leftThumbInitialPoint = (!_.isUndefined(Start) && Start + 1) || 0;
    const rightThumbInitialPoint = (!_.isUndefined(End) && End + 2) || 0;
    if (didUpdate) {
      return {
        startIndex: Start || 0,
        endIndex: End || 0,
        leftTranslatedIndex: leftThumbInitialPoint,
        rightTranslatedIndex: rightThumbInitialPoint,
        initialStart: Start || 0,
        initialEnd: End || 0,
        selectionLeft: Start || 0,
        selectionRight: End + 1 || 0,
        display: false,
      };
    }
  }

  componentWillUnmount() {
    const { actions } = this.props;
    //actions.clearMessage();
  }
  getDivDimensions = (values) => {
    this.setState({
      left: values.left,
      right: values.left + values.width,
      width: values.width,
      height: values.height,
    });
  };

  // The index where the right thumb stopped
  // two should be substracted from the end Index.
  // 1 for converting to index as index starts from 0.
  // Since right thumb stops at start of an another span, it gives index of that span.
  // To cover the delta, once should be removed.
  getRightIndex = (index) => {
    const { initialStart, initialEnd } = this.state;
    // Since the div starts at 10 and right index shows an index less
    // divide the pageX by 10 and remove two from it.

    // const {left} = this.state;
    this.setState(
      {
        endIndex: calibrateThumb(index, initialStart, initialEnd) - 1,
      },
      () => {}
    );
  };

  getRightTranslatedIndex = (index) => {
    // right index shows an index less

    this.setState(
      {
        rightTranslatedIndex: index - 1,
        selectionRight: index - 1,
      },
      () => {}
    );
  };

  // The index where the left thumb stopped
  getLeftIndex = (index) => {
    const { initialStart, initialEnd } = this.state;
    this.setState(
      {
        startIndex: calibrateThumb(index, initialStart, initialEnd),
      },
      () => {}
    );
  };

  // The index where the thumb passed by
  getLeftTranslatedIndex = (index) => {
    this.setState(
      {
        leftTranslatedIndex: index - 1,
        selectionLeft: index,
      },
      () => {}
    );
  };

  onSubmit = (editRegionConfirmed) => {
    const { startIndex, endIndex } = this.state;
    const {
      data,
      actions,
      history: {
        location: { pathname },
      },
    } = this.props;
    const { Uuid } =
      data &&
      !_.isEmpty(data) &&
      !_.isEmpty(data[0].Targets) &&
      data[0].Targets[0];
    let payload = objToCamel(data[0].AssayDesign);

    payload.targetSpecifier.editRegionDonorRange = {
      start: startIndex,
      end: endIndex,
    };
    payload.targetSpecifier.uuid = Uuid || undefined;
    payload.editRegionConfirmed = editRegionConfirmed || false;
    actions.getNewAssays([payload], editRegionConfirmed);
  };

  toggleSchematic = () => {
    this.setState({ display: true });
  };

  render() {
    const { classes, data, pageLoading } = this.props;
    const needsRedirect =
      _.isEmpty(data) ||
      (_.isEmpty(data[0].Targets) &&
        !_.isUndefined(pathname) &&
        pathname !== undefined &&
        pathname.indexOf("digital-assays/genome-confirmation") !== -1);

    if (needsRedirect) {
      return (window.location.href = "/digital-assays/assays-create/genome");
    }

    const { Errors } = !_.isEmpty(data) && !_.isEmpty(data[0]);

    const { Code, Property, Text } = !_.isEmpty(Errors) && Errors[0];

    //let validationMessage = findValidationMessage(Code);

    const {
      EditRegionDonorRange: { Start, End },
      DonorSequence,
      EditRegionSequence,
      LeftHomologyArmSequence,
      RightHomologyArmSequence,
      Uuid,
    } =
      data &&
      !_.isEmpty(data) &&
      !_.isEmpty(data[0].Targets) &&
      data[0].Targets[0];

    const processedSequence =
      DonorSequence && insertCutSites(Start, End + 1, DonorSequence);
    const {
      startIndex,
      width,
      left,
      height,
      right,
      endIndex,
      leftTranslatedIndex,
      rightTranslatedIndex,
      display,
      selectionRight,
      selectionLeft,
    } = this.state;
    const editRegionConfirmed = true;

    const btnSubmitClass = classNames({
      btn: true,
      "": !pageLoading,
      "btn-submitting": pageLoading,
    });
    const validationErrors =
      (!_.isEmpty(data) &&
        !_.isEmpty(data) &&
        !_.isEmpty(data[0].Errors) &&
        !_.isEmpty(data[0].Targets) &&
        data[0].Errors[0].Code !==
          "Target.HdrGenomeEdit.EditRegion.ConfirmationRequired" &&
        data[0].Errors) ||
      [];

    return (
      <AppWrapper id="genome-confirmation" pageTitle="Genome Confirmation">
        <div className="container main-content">
          <div className={classNames(classes.root)}>
            <Link to="/digital-assays/assays-create/genome">
              <i className="fa fa-angle-double-left" /> Back to Target Entry
            </Link>
            {/* EDIT: Remove two <br/> for vertical spaces or Create a component*/}
            <br />
            <br />
            {/* Confirmation page Header - part of the Confirmation page*/}
            <ConfirmSubmissionHeader {...classes} />
            <br />
            {/* Confirmation page description - part of the Confirmation page*/}
            <ConfirmSubmissionDescription {...classes} />
            <ConfirmSubmissionSubHeader {...classes} />
            <ConfirmSubmissionDiagram
              classes={classes}
              leftHomologyArmSequence={LeftHomologyArmSequence}
              rightHomologyArmSequence={RightHomologyArmSequence}
              editRegionSequence={EditRegionSequence}
            />
            <br />

            {display && (
              <ConfirmSubmissionSchematic classes={classes}>
                <div className="span-container">
                  {/**
                   * The initial point for the left thumb
                   * As the index starts from zero, `1` should be added to offset the difference.
                   */}

                  {
                    <Thumb
                      ref={this.leftThumbRef}
                      className="left-thumb"
                      classes={classes}
                      width={width}
                      height={height}
                      startingPoint={this.state.left} // Div starting Point for reference and limiting the moment.
                      thumbInitialPoint={leftTranslatedIndex}
                      indexCallBack={this.getLeftIndex} // Get the left index out of the components when thumb stopped
                      getTranslatedIndex={this.getLeftTranslatedIndex} // Get the translated index - Left Thumb
                      left={true}
                    />
                  }
                  {/*Redundant components Right thumb and Left thumb - Can be combined into one.*/}
                  {/**
                   * The initial point for the right thumb
                   * As the index starts from zero, `1` should be added to offset the difference.
                   */}
                  {
                    <Thumb
                      ref={this.rightThumbRef}
                      className="right-thumb"
                      classes={classes}
                      width={width}
                      height={height}
                      startingPoint={this.state.left} // Div starting Point for reference and limiting the moment.
                      thumbInitialPoint={rightTranslatedIndex}
                      indexCallBack={this.getRightIndex} // Get the right index out of the components when thumb stopped
                      getTranslatedIndex={this.getRightTranslatedIndex} // Get the translated index - Right Thumb
                      right={true}
                    />
                  }

                  <GeneEditSequenceDisplay
                    selectedText={true}
                    classes={classes}
                    sequenceList={processedSequence}
                    selectionPoints={[selectionLeft, selectionRight]}
                    sendBackState={this.getDivDimensions}
                  />
                </div>
              </ConfirmSubmissionSchematic>
            )}
            <br />
            {validationErrors && !_.isEmpty(validationErrors) && (
              <ValidationErrorComponent {...validationErrors} />
            )}
            <HorizontalBar {...classes} />

            {display && (
              <div className="row d-flex justify-content-start align-items-center">
                <div className="col-auto">
                  <button
                    id="update-assay-btn"
                    type="button"
                    disabled={pageLoading}
                    className={btnSubmitClass}
                    onClick={(e) => {
                      e.preventDefault();
                      this.onSubmit();
                    }}
                  >
                    {!pageLoading ? "Update Diagram of Donor" : "Updating..."}
                    {pageLoading && (
                      <CircularProgress
                        className={classes.progress}
                        size={20}
                        thickness={4}
                      />
                    )}
                  </button>
                </div>

                <div className="col-4">
                  <button
                    id="cancel-assay-btn"
                    type="button"
                    className={classNames(
                      "btn btn-block btn-light cancel-btn",
                      classes.cancel_button
                    )}
                    onClick={() => {
                      this.setState({ display: false });
                    }}
                  >
                    <i className="fa fa-times"></i> cancel
                  </button>
                </div>
              </div>
            )}
            {!display && (
              <div className="row d-flex justify-content-start col-5">
                <div className="col-auto">
                  <button
                    id="update-assay-btn"
                    type="button"
                    className="rounded outline"
                    onClick={(e) => {
                      e.preventDefault();
                      this.toggleSchematic();
                    }}
                  >
                    Modify
                  </button>
                </div>

                <div className="col">
                  <button
                    id="confirm-assay-btn"
                    type="button"
                    disabled={pageLoading}
                    className={btnSubmitClass}
                    onClick={(e) => {
                      e.preventDefault();
                      this.onSubmit(editRegionConfirmed);
                    }}
                  >
                    {!pageLoading ? "Confirm" : "Confirming..."}
                    {pageLoading && (
                      <CircularProgress
                        className={classes.progress}
                        size={20}
                        thickness={4}
                      />
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </AppWrapper>
    );
  }
}

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});
const stateToProps = (state) => ({
  pageLoading: (state && state.assays && state.assays.pageLoading) || false,
  data:
    (state &&
      !_.isEmpty(state) &&
      !_.isEmpty(state.assays) &&
      !_.isEmpty(state.assays.validatedAssayDetails.data) &&
      state.assays.validatedAssayDetails.data) ||
    {},
});

ConfirmSubmission = withStyles(styles)(ConfirmSubmission);

export default ConfirmSubmission = connect(
  stateToProps,
  dispatchToProps
)(ConfirmSubmission);
